import { AccountProvider } from '../context';
import React from 'react';
import { AccountTable } from './List/AccountTable';
import { Detail } from './Form';
import { Authorize } from '@/core';
import { Button } from '@/components';
import { useHandleActionItem } from '@/components/hooks/useHandleActionItem';
import { PERMISSIONS } from '@/contants';

export const AccountListScreen: React.FC<unknown> = () => {
  const { open, handleClose, setOpen, handleClickCreate } = useHandleActionItem();

  return (
    <>
      <AccountProvider>
        <div className='bg-white py-4 px-4 flex flex-col flex-wrap'>
          <div className='ml-auto'>
            <Button
              type='primary'
              size='middle'
              onClick={() => handleClickCreate()}
              className='rounded'
            >
              + Create
            </Button>
          </div>
          <div>
            <AccountTable />
            <Detail open={open} handleClose={handleClose} setOpen={setOpen} />
          </div>
        </div>
      </AccountProvider>
    </>
  );
};

export const AccountList = Authorize<unknown>(AccountListScreen, PERMISSIONS.USERS.VIEW);
